import { useUser } from "@clerk/react-router";
import { useSessionContext } from "../../api";
import { usePanelId, useUpdateSessionContext } from "../../api/hooks";
import { ClerkTopbarUserButton } from "../../auth/ClerkAuthBoundary";
import { HelpSupportDropdown } from "./HelpSupport";
import { NotificationsDropdown } from "./NotificationsDropdown";

interface TopbarProps {
  onMenuClick: () => void;
  title: string;
}

export function Topbar({ onMenuClick, title }: TopbarProps) {
  const { user } = useUser();
  const email =
    user?.primaryEmailAddress?.emailAddress ??
    user?.emailAddresses[0]?.emailAddress;
  const panelId = usePanelId();
  const sessionContextQuery = useSessionContext({ panelId });
  const updateSessionContext = useUpdateSessionContext(email);

  function handlePanelChange(panelId: number) {
    void updateSessionContext.mutateAsync(panelId);
  }

  return (
    <div className="topbar">
      <div className="topbar-left">
        <button
          aria-label="Open navigation"
          className="mobile-menu-btn"
          onClick={onMenuClick}
          type="button"
        >
          <svg
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            aria-hidden="true"
          >
            <path d="M3 5h14M3 10h14M3 15h14" strokeLinecap="round" />
          </svg>
        </button>
        <div className="topbar-title title-sm">{title}</div>
      </div>
      <div className="topbar-right">
        {sessionContextQuery.data &&
          sessionContextQuery.data.profiles.length > 1 && (
            <select
              aria-label="Switch panel profile"
              className="topbar-panel-switch"
              value={String(sessionContextQuery.data.activePanelId)}
              onChange={(event) =>
                handlePanelChange(Number.parseInt(event.target.value, 10))
              }
            >
              {sessionContextQuery.data.profiles.map((profile) => (
                <option key={profile.panelId} value={profile.panelId}>
                  {profile.panelName}
                </option>
              ))}
            </select>
          )}
        <NotificationsDropdown />
        <HelpSupportDropdown />
        <ClerkTopbarUserButton />
      </div>
    </div>
  );
}
